<template>
  <div class="bg-f3f4f7 flex-1 ">
<!--    <div class="flex mb-10 plr-20 align-center bg-ff">-->
<!--      <div class="title flex align-center mr-20 mtb-10">-->
<!--        <div class="decoration-line mr-5"></div>-->
<!--        <div class="font-16-f5971d font-bold">{{titleName}}</div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="flex mb-10">
      <div class="btn-24-bg-ff flex align-center mr-5 button" @click="onAdd">
        <img src="/static/images/add.png" class="icon-14 mr-5" alt="">
        添加核算项目
      </div>
    </div>
    <div class="mtb-10 bg-ff" v-for="(item, index) in tableData" :key="index">
      <div class="flex p-10 align-center">
        <div class="flex font-12-30313a font-bold text-left">{{item.name ? item.name : '暂无分组名称'}}</div>
        <div class="flex align-center mr-5 button btn-24-bd-30313a mlr-20" @click="deleteGroup(item.id)">
          <img src="/static/images/shanchu1.png" class="icon-12-14 mr-5" alt="">
          删除
        </div>
        <div class="flex align-center mr-5 button btn-24-bd-30313a" @click="openReport(item.id)" v-if="permission.includes('contractPrint')">
          <img src="/static/images/daying.png" class="icon-12-14 mr-5" alt="">
          打印
        </div>
      </div>
      <div style="min-height: 300px">
        <erp-table :is-edit="true" :customs="[{field: 'formulaCompute', visible: isOpen}]" :editable-status="editableStatus" ref="erpTable" :table-data="item.contractItemList"  :loading="loading" :column-data="columnData" @on-modify="onModifyRow" modify-method="on-modify"></erp-table>
      </div>
      <!--<move-vertical :max="560" :min="200" moveDom="bottom" moveId="moveBottomM"></move-vertical>-->
    </div>
    <el-dialog title="选择预算模板" :visible.sync="isShow" width="85%" class="handlePlan" @closed="onClose">
      <div class="p-20">
        <div class="flex flex-wrap">
          <div class="w-320 bg-f3f4f7 h-167 mr-20 mb-20" v-for="(item,index) in groups" :key="index">
            <div class="flex p-20">
              <div class="flex-column text-left">
                <div class="font-18-30313a">{{item.name}}</div>
                <div class="font-12-b9b9b9">创建日期：{{item.createTime ? Utils.formatTime(item.createTime) : '-'}}</div>
              </div>
              <div class="flex flex-1 justify-end pl-12" v-if="item.isSelect"><button style="width:46px" class="btn-30-border-30313a-small" @click="selected(item.id)">选择</button></div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
     <!--打印-->
    <el-dialog title="打印" :visible.sync="isReportShow" :fullscreen="true" class="flex-column" width="85%">
      <report :classify-id="8" :id="this.contractId"></report>
    </el-dialog>
  </div>
</template>
<script>
import ErpTable from '../../../components/ErpTable'
import MoveVertical from '../../../components/MoveVertical'
import Report from '../../../components/Report'
export default {
  name: 'cost-accounting',
  components: {ErpTable, MoveVertical, Report},
  props: ['titleName', 'info', 'budgetGroup'],
  data () {
    return {
      loading: false,
      isOpen: false,
      tableFooter: [
        {
          columns: ['budgetResult', 'increaseDecrease', 'settlementResult'],
          type: 'sum',
          name: '合计'
        }
      ],
      columnData: [
        {
          type: 'index',
          title: '序号',
          width: '60',
          fixed: 'left'
        }, {
          field: 'specialItem',
          title: '代码',
          width: '100'
        }, {
          field: 'name',
          title: '项目内容',
          width: '280'
        }, {
          field: 'formulaCompute',
          title: '计算公式',
          width: '180'
        }, {
          field: 'budgetResult',
          title: '预算金额',
          width: '80',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'increaseDecrease',
          title: '增减金额',
          width: '80'
        }, {
          field: 'settlementResult',
          title: '结算金额',
          width: '80',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'description',
          title: '说明',
          minWidth: '200',
          editRender: {
            name: 'input'
          }
        }
      ],
      tableData: [],
      editableStatus: true,
      isShow: false,
      type: [],
      groups: [],
      isReportShow: false,
      contractId: null
    }
  },
  created () {
    this.getPermission()
    this.getGroupList()
    this.group()
  },
  methods: {
    openReport (id) {
      this.contractId = id
      this.isReportShow = true
    },
    getPermission () {
      this.axios.post(`${this.$store.state.API_URL_9010}/permission/permissionStr`, {
        parent: 'budget',
        parentGroup: 'budget'
      }).then(res => {
        if (res.data.success) {
          this.permission = res.data.data.split(',')
          if (this.permission.includes('showFormula')) {
            this.isOpen = true
          }
        }
      })
    },
    group () {
      let params = {
        isCustomer: 1,
        customerId: this.info.id,
        companyId: this.$store.state.companyId
      }
      this.axios.post('contractTemplate/list', params).then(res => {
        if (res.data.success) {
          this.groups = res.data.data
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    getGroupList () {
      let params = {
        customerId: this.info.id
      }
      this.axios.post('contract/list', params).then(res => {
        if (res.data.success) {
          let data = res.data.data
          data.forEach(item => {
            item.contractItemList.forEach(list => {
              if (list.isModified === 1) {
                list.unEditable = 'budgetResult, settlementResult,description'
              } else {
                list.unEditable = 'description'
              }
            })
          })
          this.tableData = data
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    deleteGroup (id) {
      this.$confirm('此操作将永久删除该项目, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          id: id
        }
        this.axios.post('contract/deleteById', this.qs.stringify(params)).then(res => {
          if (res.data.success) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.getGroupList()
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    onModifyRow (row) {
      let params = {
        id: row.id,
        description: row.description
      }
      if (row.budgetResult) {
        params.budgetResult = row.budgetResult
      }
      if (row.settlementResult) {
        params.settlementResult = row.settlementResult
      }
      this.axios.post('contractItem/modify', params).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功')
          this.getGroupList()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    selected (id) {
      let params = {
        templateId: id,
        customerId: this.info.id,
        companyId: this.$store.state.companyId
      }
      this.axios.post('contract/selectTemplate', params).then(res => {
        if (res.data.success) {
          this.$message.success('新增成功')
          this.isShow = false
          this.getGroupList()
        } else {
          this.isShow = false
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onAdd () {
      this.isShow = true
    },
    onClose () {
      this.isShow = false
    },
    onSubmit () {
    }
  }
}
</script>

<style scoped>
  .decoration-line {
    width: 4px;
    height: 16px;
    background-color: #f5971d;
    border-radius: 4px;
  }
  .w-320{
    width: 320px;
  }
  .w-135{
    width: 135px;
  }
  .h-135{
    height: 135px;
  }
  .min-h-69{
    min-height: 69px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/customer/budgetItem/costAccounting.vue